/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS')
  .component('zcsSetTagButton', {
    bindings: {
      project: '<',
    },
    transclude: true,
    templateUrl: '/templates/zenclerk_s/sites/dashboard/set-tag-button.html',
    controller: ZcsSetTagButtonController,
  });

ZcsSetTagButtonController.$inject = ['$state'];
function ZcsSetTagButtonController($state) {
  const vm = this;

  vm.$onInit = () => {
    vm.goToTagSetupPage = goToTagSetupPage;
  };

  function goToTagSetupPage() {
    $state.go('zenclerkS.project.tags.tracking', { apikey: vm.project.apikey });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/dashboard/set-tag-button.js